const isFocusInside = (event: React.FocusEvent) =>
  event.currentTarget.contains(event.relatedTarget)
export const onFocusOutside =
  (callback: () => void) => (event: React.FocusEvent) => {
    if (!isFocusInside(event)) callback()
  }
